import React from "react";
import { useTranslation } from "react-i18next";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import { ApiPut } from "../helper/axiosFunctions";
import { commonToast } from "../helper/Toast";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Loading from "../components/Loading";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("email_invalid").required("email_required"),
});

export default function EmailPage() {
  const { t } = useTranslation();
  const userData = JSON.parse(localStorage?.getItem("zubrus_user_data"))?.data;

  const handleSubmit = async (values, { setSubmitting }) => {
    const body = {
      userId: userData?.userInfo?.userId,
      username: userData?.userInfo?.username,
      email: values.email,
    };
    try {
      const response = await ApiPut(`/users`, body);
      if (response.code === 200) {
        commonToast(t("emailupdated"), "success");
        const updatedUserData = {
          ...userData,
          userInfo: {
            ...userData?.userInfo,
            email: values.email,
          },
        };
        localStorage.setItem(
          "zubrus_user_data",
          JSON.stringify({ data: updatedUserData })
        );
      }
    } catch (error) {
      commonToast(error?.data?.error || error?.message, "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto py-10 md:px-4">
      <div className="flex items-center md:gap-2 mb-10">
        <Link
          to="/profile"
          className="border cursor-pointer rounded-full flex justify-center items-center size-10"
        >
          <FaLongArrowAltLeft />
        </Link>
        <h3 className="text-lg font-bold flex-1 text-center">{t("email")}</h3>
      </div>

      <Formik
        initialValues={{ email: userData?.userInfo?.email || "" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className="relative">
              <div className="mb-1 absolute z-10 mt-1.5 flex justify-between w-full px-4 text-sm text-gray-500">
                <label>{t("email")}</label>
              </div>
              <Field
                type="text"
                name="email"
                placeholder={t("email")}
                className="border h-[56px] w-full z-20 relative rounded-xl bg-transparent px-4 py-2 shadow-inner outline-none placeholder:text-gray-500 text-black tracking-widest pt-5"
              />
              <ErrorMessage
                name="email"
                component="div"
                className="text-red-500 text-sm mt-1"
              />
            </div>

            <h3 className="text-sm text-gray-500 mt-4">
              {t("emailconfimmsg")}
            </h3>

            <button
              type="submit"
              className="primary-btn w-full mt-5"
              disabled={isSubmitting}
            >
              {isSubmitting ? <Loading /> : t("save")}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}
